import { render, staticRenderFns } from "./accept_invite.vue?vue&type=template&id=83ba997e&scoped=true&"
import script from "./accept_invite.vue?vue&type=script&lang=js&"
export * from "./accept_invite.vue?vue&type=script&lang=js&"
import style0 from "./accept_invite.vue?vue&type=style&index=0&id=83ba997e&scoped=true&lang=css&"
import style1 from "./accept_invite.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ba997e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83ba997e')) {
      api.createRecord('83ba997e', component.options)
    } else {
      api.reload('83ba997e', component.options)
    }
    module.hot.accept("./accept_invite.vue?vue&type=template&id=83ba997e&scoped=true&", function () {
      api.rerender('83ba997e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/onboarding/client/collaborator/accept_invite.vue"
export default component.exports